import { useState } from 'react'
import { NodeResizer } from '@xyflow/react'

const GROUP_COLORS = [
  { label: 'Blue',   bg: 'rgba(98,114,241,0.06)',  border: 'rgba(98,114,241,0.35)'  },
  { label: 'Purple', bg: 'rgba(139,92,246,0.06)',  border: 'rgba(139,92,246,0.35)'  },
  { label: 'Green',  bg: 'rgba(16,185,129,0.06)', border: 'rgba(16,185,129,0.35)'  },
  { label: 'Yellow', bg: 'rgba(234,179,8,0.06)',   border: 'rgba(234,179,8,0.35)'   },
  { label: 'Red',    bg: 'rgba(239,68,68,0.06)',   border: 'rgba(239,68,68,0.35)'   },
]

export default function GroupNode({ id, data, selected }) {
  const [label, setLabel] = useState(data?.label || 'Group')
  const [editingLabel, setEditingLabel] = useState(false)
  const [colorIdx, setColorIdx] = useState(data?.colorIdx || 0)
  const color = GROUP_COLORS[colorIdx]

  return (
    <>
      <NodeResizer
        isVisible={selected}
        minWidth={200}
        minHeight={150}
        handleStyle={{ background: '#6272f1', width: 8, height: 8 }}
        lineStyle={{ borderColor: color.border }}
      />
      <div
        className="w-full h-full rounded-2xl relative"
        style={{
          background: color.bg,
          border: `2px solid ${color.border}`,
          minWidth: 200,
          minHeight: 150,
        }}
      >
        {/* Label bar */}
        <div
          className="flex items-center gap-2 px-3 py-1.5"
          style={{ borderBottom: `1px solid ${color.border}` }}
        >
          {editingLabel ? (
            <input
              autoFocus
              className="bg-transparent outline-none text-xs font-semibold flex-1"
              style={{ color: color.border }}
              value={label}
              onChange={e => setLabel(e.target.value)}
              onBlur={() => setEditingLabel(false)}
              onKeyDown={e => (e.key === 'Enter' || e.key === 'Escape') && setEditingLabel(false)}
            />
          ) : (
            <span
              className="text-xs font-semibold cursor-pointer flex-1 truncate"
              style={{ color: color.border }}
              onDoubleClick={() => setEditingLabel(true)}
            >
              {label}
            </span>
          )}

          {/* Color dots */}
          <div className="flex gap-1 flex-shrink-0">
            {GROUP_COLORS.map((c, i) => (
              <button
                key={i}
                onClick={() => setColorIdx(i)}
                className={`w-2.5 h-2.5 rounded-full transition-transform ${colorIdx === i ? 'scale-125' : 'opacity-40 hover:opacity-100'}`}
                style={{ background: c.border }}
              />
            ))}
          </div>
        </div>

        {/* Hint text when empty */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-20" style={{ top: 32 }}>
          <span className="text-xs" style={{ color: color.border }}>Drop nodes here</span>
        </div>
      </div>
    </>
  )
}
